import { render, staticRenderFns } from "./HotDestinationsCityCard.vue?vue&type=template&id=68baa6a7&scoped=true"
import script from "./HotDestinationsCityCard.vue?vue&type=script&lang=js"
export * from "./HotDestinationsCityCard.vue?vue&type=script&lang=js"
import style0 from "./HotDestinationsCityCard.vue?vue&type=style&index=0&id=68baa6a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68baa6a7",
  null
  
)

export default component.exports